import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Helmet } from "@/components/Helmet";

const TechnicalDetails = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Technical Details - ShadowScan</title>
        <meta
          name="description"
          content="Technical details of the ShadowScan managed WordPress security service."
        />
      </Helmet>
      <Navigation />
      <main className="flex-grow pt-24">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-heading font-bold">Technical Details</h1>
          <p className="mt-4 text-lg text-muted-foreground">
            This page will contain a deeper dive into the technical architecture and methodologies of ShadowScan.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TechnicalDetails;
